<template>
    <Head title="Security" />
    <div class="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        <div
            class="bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-gray-200 mb-8 max-w-[60rem] mx-auto py-10 px-5"
        >
            <Security />
        </div>
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Security from '@/components/security/index.vue';
</script>
